// extracted by mini-css-extract-plugin
export default {"btn":"XZ_A7E8y","notes":"cbBJ2SLo","mobile":"mobile","description":"hSGO58CH","text":"mrFyEo1Y","desktop":"desktop","link":"gNVHGfvJ","close":"oYRDborv","more":"FlwpS6Pq"};